<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <div>
      <el-button icon="el-icon-back" type="primary" size="mini" @click="goBack">
        返回
      </el-button>
      <span class="detail ml-20px">
        <span class="ml-20px text-18px">审批数据修改</span>
      </span>
    </div>
    <el-row :gutter="20" class="h-[calc(100%-38px)] mt-10px">
      <el-col :span="6" class="h-full border-r-1">
        <div class="h-100px overflow-y-auto">
          <div><span class="border-l-3 border-color-primary pl-10px text-18px">基本信息</span></div>
          <div class="mt-10px text-16px pl-10px" v-loading="baseInfoLoading">
            <div class="truncate mt-10px">批次编号： {{ baseInfo.batchCode }}</div>
          </div>
        </div>
        <div class="mt-20px h-[calc(100%-120px)]">
          <div>
            <span class="border-l-3 border-color-primary pl-10px text-18px">表字段详情</span>
          </div>
          <el-table
            border
            :data="entityList"
            :loading="entityLoading"
            height="calc(100% - 34px)"
            class="mt-10px"
            @row-click="getEntityData"
            ref="entityTableRef"
          >
            <el-table-column show-overflow-tooltip prop="name" label="实体名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="code" label="实体编码"></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col class="h-full" :span="18">
        <div class="h-full w-full" id="gc-designer-container"></div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import DataApprovalService from '@/services/dataApprovalService'
import defaultJson from './defaultJson'

export default {
  name: 'approvalDataEdit',
  created() {
    // 根据路由中的批次id获取批次基本信息
    this.batchId = this.$route.query.batchId
    if (!this.batchId) return
    this.getBatchDataInfo()
    this.getEntityList()
  },
  mounted() {
    this.initSheet()
  },
  data() {
    return {
      entityContent: '',
      saveSuceess: false,
      scopeDistuibutionVisible: false,
      standardList: [],
      standardId: '',
      treeData: [],
      defaultTreeProps: {
        label: 'name',
        children: 'childList',
        isLeaf: 'isLeaf',
      },
      spread: null,
      excelIo: null,
      sheet: null,
      designer: null,
      currentNode: null,
      entityLoading: false, // 实体列表loading
      entityList: [], // 实体列表数据
      baseInfo: {
        batchCode: '', // 批次编号
        approveStatus: 0, // 审批状态
        flowTaskId: '', // 流程状态
      },
      baseInfoLoading: false, // 获取批次信息loading
      batchId: '', // 批次id
      currentEntityData: null, // 当前点击项实体
      columns: [], // 当前所有列信息
    }
  },
  methods: {
    /**
     * @description 返回
     */
    goBack() {
      this.$router.go(-1)
    },

    /**
     * @description 获取实体数据列表数据
     */
    async getEntityList() {
      this.entityLoading = true
      const res = await DataApprovalService.getBatchEntity({
        batchId: this.batchId,
      })
      this.entityLoading = false
      if (res && res.data && res.code === 0) {
        this.entityList = res.data
        this.$nextTick(() => {
          this.$refs.entityTableRef?.doLayout()
        })
      }
    },

    /**
     * @description 获取批次基本信息
     */
    async getBatchDataInfo() {
      this.baseInfoLoading = true
      const res = await DataApprovalService.getBatchInfo({
        id: this.batchId,
      })
      this.baseInfoLoading = false
      if (res && res.data && res.code === 0) {
        this.baseInfo = res.data
      }
    },

    /**
     * @description 获取实体数据
     */
    async getEntityData(entityData) {
      this.currentEntityData = { ...entityData }
      await this.getEntityDataHeaderList()
      this.getEntityDataList()
    },

    /**
     * @description 获取实体下数据列表表头
     */
    async getEntityDataHeaderList() {
      if (!this.currentEntityData) return
      this.dataLoading = true
      const res = await DataApprovalService.getDynamicTableHeader({
        classId: this.currentEntityData.id,
      })
      this.dataLoading = false
      if (res && res.data && res.code === 0) {
        this.entityDataTableHeader = res.data
        this.bindCellColumns()
      }
    },

    /**
     * @description 获取实体下数据
     */
    async getEntityDataList() {
      if (!this.currentEntityData) return
      this.dataLoading = true
      const res = await DataApprovalService.getBatchEntityData({
        batchId: this.batchId,
        classId: this.currentEntityData.id,
      })
      this.dataLoading = false
      if (res && res.data && res.code === 0) {
        this.dataList = res.data
        this.initDataSource()
      }
    },

    /**
     * @description spreadjs单元格数据绑定
     */
    bindCellColumns() {
      const entityDataTableHeader = this.entityDataTableHeader.filter((item) => {
        return item.code !== 'ApproveStatus'
      }) // 移除'审批状态'列
      defaultJson.sheets.Sheet1.tables[0].columns = _.map(entityDataTableHeader, (i, index) => {
        return {
          id: index,
          name: i.name,
          dataField: i.name,
          columnName: i.columnName,
        }
      })
      this.columns = [...entityDataTableHeader]
      defaultJson.sheets.Sheet1.tables[0].columns.push({
        id: defaultJson.sheets.Sheet1.tables[0].columns.length,
        name: 'id',
        dataField: 'id',
        columnName: 'id',
      })
      defaultJson.sheets.Sheet1.tables[0].colCount =
        defaultJson.sheets.Sheet1.tables[0].columns.length
      defaultJson.sheets.Sheet1.tables[0].bindingPath = this.currentEntityData.name
      this.$nextTick(() => {
        this.sheet = this.spread.getActiveSheet()
        this.spread.fromJSON(defaultJson)
      })
      // this.initDataSource()
    },

    /**
     * @description 提交审核
     */
    async dataBatchSubmit() {
      const res = await DataApprovalService.batchDataReapply({
        batchId: this.batchId,
      })
      if (res?.code === 0) {
        this.$message.success('提交成功')
      }
    },

    /**
     * @description 保存表格数据
     */
    async insertCollectData() {
      const currentCellData = this.sheet.getDataSource().getSource()
      // 清除掉数据全被清空项(除id外)
      _.forEach(Object.keys(currentCellData), (key) => {
        const values = currentCellData[key]
        currentCellData[key] = _.filter(values, (item) => {
          const valueList = Object.values(item)
          const dataValueList = valueList.slice(0, valueList.length - 1) // 除去添加的id项(被隐藏，无法删除)
          return _.find(dataValueList, (valueItem) => {
            return valueItem !== null
          })
        })
      })
      const res = await DataApprovalService.updateBatchData({
        batchId: this.batchId,
        data: JSON.stringify(currentCellData),
        classId: this.currentEntityData.id,
      })
      if (res && res.code === 0) {
        this.$message.success('成功')
      }
    },

    /**
     * @description 初始化数据源
     */
    initDataSource() {
      const entityDataTableHeader = this.entityDataTableHeader.filter((item) => {
        return item.code !== 'ApproveStatus'
      }) // 移除'审批状态'列
      const columnNames = _.map(entityDataTableHeader, (i, index) => {
        return {
          id: index,
          name: i.name,
          dataField: i.name,
          columnName: `${i.tableName}.${i.columnName}`,
        }
      })
      columnNames.push({
        id: defaultJson.sheets.Sheet1.tables[0].columns.length,
        name: 'id',
        dataField: 'id',
        columnName: 'id',
      })
      const jsonData = this.spread.toJSON()
      const dataObject = {}
      _.forEach(jsonData.sheets, (sheet) => {
        _.forEach(sheet.tables, (i) => {
          dataObject[i.bindingPath] = []
          _.forEach(this.dataList, (item, index) => {
            dataObject[i.bindingPath][index] = {}
            _.forEach(columnNames, (k) => {
              dataObject[i.bindingPath][index][k.name] = item[k.columnName]
            })
          })
        })
      })
      this.sheet = this.spread.getActiveSheet()
      this.sheet.setColumnVisible(defaultJson.sheets.Sheet1.tables[0].columns.length - 1, false) // 隐藏id列
      this.spread.suspendPaint()
      this.sheet.bind(GC.Spread.Sheets.Events.EditStarting, (e, info) => {
        const col = info.col
        const rowData = Object.values(this.sheet.getDataSource().getSource())[0][info.row - 1]
        if (rowData?.id) {
          // 已存在的数据某些属性不能编辑
          const propertyName = Object.keys(rowData)[col] // 对应属性name
          const propertyItem = _.find(entityDataTableHeader, (item) => {
            return item.name === propertyName
          }) // 属性name对应的完整属性
          if (propertyItem?.isPrimary) {
            info.cancel = true
          }
        }
        if (col >= columnNames.length - 1) {
          // 其它无属性列也不能编辑
          info.cancel = true
        }
      })
      const source = new GC.Spread.Sheets.Bindings.CellBindingSource(dataObject)
      this.sheet.setDataSource(source)
      this.initCellValid()
      this.spread.resumePaint()
      this.disableMenu()
    },

    /**
     * @description 禁用右键菜单某些功能
     */
    disableMenu() {
      for (let i = 0; i < this.spread.contextMenu.menuData.length; i += 1) {
        const item = this.spread.contextMenu.menuData[i]
        if (item.command === 'tableDelete') {
          // 删除
          // this.spread.contextMenu.menuData.splice(i, 1)
          if (item.subMenu?.length) {
            const index = _.findIndex(item.subMenu, (subItem) => {
              return subItem.command === 'tableDeleteColumnsForContextMenu'
            })
            if (index !== -1) {
              item.subMenu.splice(index, 1) // 禁用删除列功能
            }
          }
        }

        if (item.command === 'tableInsert') {
          if (item.subMenu?.length) {
            // 插入
            for (let curIndex = 0; curIndex < item.subMenu.length; curIndex += 1) {
              if (
                [
                  'tableInsertColumnsLeftForContextMenu',
                  'tableInsertColumnsRightForContextMenu',
                ].includes(item.subMenu[curIndex].command)
              ) {
                item.subMenu.splice(curIndex, 1) // 禁用插入列功能
                curIndex -= 1
              }
            }
          }
        }
      }
    },

    /**
     * @description 初始化表格校验规则
     */
    initCellValid() {
      this.spread.options.highlightInvalidData = true
      const headerNameList = [...defaultJson.sheets.Sheet1.tables[0].columns] // 表头name list
      // 获取每列对应的校验
      _.forEach(headerNameList, (headerItem, colIndex) => {
        const columnItem = _.find(this.columns, (column) => {
          return column.name === headerItem.name
        })
        if (columnItem) {
          let isRequired = false // 是否必填
          let lengthLimmit = false // 是否有字符串输入长度校验
          let customType = '' // 自定义校验类型
          let customReg = null // 自定义校验正则
          let customRegTipStr = '' // 自定义校验正则提示
          if (columnItem.isNullable) {
            // 必填
            isRequired = true
          }
          if (columnItem.valueType === 1) {
            // 字符串长度限制
            lengthLimmit = true
          } else if (columnItem.valueType === 2) {
            // 整数
            customType = 'integer'
            customReg = /^-?\d+$/
            customRegTipStr = '该字段数据必须为整数'
          } else if (columnItem.valueType === 3) {
            // 小数
            customType = 'decimals'
            customReg = /^-?\d+.\d+$/
            customRegTipStr = '该字段数据必须为小数'
          } else if (columnItem.valueType === 6) {
            // 日期时间
            customType = 'datetime'
            customReg = /^\d{4}[-/]\d{2}[-/]\d{2} \d{2}:\d{2}:\d{2}$/
            customRegTipStr =
              '该字段数据必须为日期时间格式，例如：2020-10-10 10:10:10或2020/10/10 10:10:10'
          } else if (columnItem.valueType === 8) {
            // 日期
            customType = 'date'
            customReg = /^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/
            customRegTipStr = '该字段数据必须为日期格式，例如：2020-10-10或2020/10/10'
          } else if (columnItem.valueType === 9) {
            // 时间
            customType = 'time'
            customReg = /^\d{2}:\d{2}:\d{2}$/
            customRegTipStr = '该字段数据必须为时间格式，例如：10:10:10'
          }

          // 给每个单元格设置对应的校验提示
          for (let rowIndex = 1; rowIndex <= this.dataList.length; rowIndex += 1) {
            // 必填项且该字段没有值
            if (isRequired && lengthLimmit) {
              // 添加提示
              this.addValidTip(
                rowIndex,
                colIndex,
                `该字段为必填项,且字符串最大长度不超过${columnItem.length}`,
                true,
                true,
                columnItem.length
              )
            } else {
              if (isRequired) {
                // 添加提示
                this.addValidTip(rowIndex, colIndex, '该字段为必填项', true, false)
              }

              if (lengthLimmit) {
                // 添加提示
                this.addValidTip(
                  rowIndex,
                  colIndex,
                  `字符串长度不能超过${columnItem.length}`,
                  false,
                  true,
                  columnItem.length
                )
              } else if (customType) {
                if (['date', 'datetime', 'time'].includes(customType)) {
                  this.sheet.getCell(rowIndex, colIndex).formatter('@')
                }
                this.customCellRule(rowIndex, colIndex, customReg, customRegTipStr)
              }
            }
          }
        }
      })
    },

    /**
     * @description 添加校验提示语
     * @param {Number} rowIndex 横坐标
     * @param {Number} colIndex 纵坐标
     * @param {String} tipText 提示语
     * @param {Boolean} isRequired 是否必填
     * @param {Boolean} isLengthLimit 是否有字符长度限制
     * @param {Number} limitLength 字符长度限制数
     */
    addValidTip(rowIndex, colIndex, tipText, isRequired, isLengthLimit, limitLength) {
      this.spread.options.highlightInvalidData = true
      let dv
      if (isLengthLimit) {
        dv = GC.Spread.Sheets.DataValidation.createTextLengthValidator(
          GC.Spread.Sheets.ConditionalFormatting.ComparisonOperators.lessThan,
          `${limitLength}`
        )
      } else if (isRequired) {
        dv = GC.Spread.Sheets.DataValidation.createTextLengthValidator(
          GC.Spread.Sheets.ConditionalFormatting.ComparisonOperators.greaterThan,
          '0'
        )
      }
      dv.showInputMessage(true)
      // dv.inputMessage(`该字段为必填项,且字符串最大长度不超过${columnItem.length}`)
      dv.inputMessage(tipText)
      dv.showErrorMessage(false)
      dv.highlightStyle({
        type: GC.Spread.Sheets.DataValidation.HighlightType.dogEar,
        color: 'red',
        position: GC.Spread.Sheets.DataValidation.HighlightPosition.topRight,
      })
      this.sheet.setDataValidator(rowIndex, colIndex, 1, 1, dv, GC.Spread.Sheets.SheetArea.viewport)
    },

    /**
     * @description 自定义校验规则
     * @param {Number} rowIndex 横坐标
     * @param {Number} colIndex 纵坐标
     * @param {RegExp} customReg 正则表达式
     * @param {String} tipText 提示语
     */
    customCellRule(rowIndex, colIndex, customReg, tipText) {
      this.spread.options.highlightInvalidData = true
      function CustomerCondition() {
        this.conditionType = 'CustomerCondition'
      }
      CustomerCondition.prototype = new GC.Spread.Sheets.ConditionalFormatting.Condition()
      CustomerCondition.prototype.evaluate = (evaluator, baseRow, baseColumn, actualValue) => {
        if (actualValue !== 0 && !actualValue) {
          return false
        }
        return customReg.test(actualValue)
      }
      const condi = new CustomerCondition()
      const dv = new GC.Spread.Sheets.DataValidation.DefaultDataValidator(condi)
      dv.ignoreBlank(false)
      dv.type(GC.Spread.Sheets.DataValidation.CriteriaType.custom)

      dv.showInputMessage(true)
      dv.inputMessage(tipText)
      dv.showErrorMessage(false)
      dv.highlightStyle({
        type: GC.Spread.Sheets.DataValidation.HighlightType.dogEar,
        color: 'red',
        position: GC.Spread.Sheets.DataValidation.HighlightPosition.topRight,
      })
      this.sheet.setDataValidator(rowIndex, colIndex, 1, 1, dv, GC.Spread.Sheets.SheetArea.viewport)
    },

    /**
     * @description 表格必填项校验
     * @returns {Boolean} 数据是否全部校验通过
     */
    validCell() {
      this.spread.options.highlightInvalidData = true
      const dataSource = this.sheet.getDataSource().getSource() // 表格所有数据(包括表头)

      const headerNameList = [...defaultJson.sheets.Sheet1.tables[0].columns] // 表头name list

      const notFilledFileds = new Set() // 有必填项未填写的字段
      // 获取每列对应的校验
      _.forEach(headerNameList, (headerItem) => {
        const columnItem = _.find(this.columns, (column) => {
          return column.name === headerItem.name
        })
        if (columnItem && columnItem.isNullable) {
          const valueList = Object.values(dataSource)
          _.forEach(valueList[0], (item) => {
            if (!item[columnItem.name]) {
              notFilledFileds.add(columnItem.name)
            }
          })
        }
      })
      return [...notFilledFileds]
    },

    /**
     * @description 获取实体树
     */
    async getEntityTree() {
      const res = await StandardManagementService.getEntityTreeData({ standardId: this.standardId })
      this.treeData = res
    },

    closeScope() {
      this.scopeDistuibutionVisible = false
    },
    down(blob) {
      const url = window.URL.createObjectURL(blob)
      // 创建隐藏的可下载链接
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', 'excel.xlsx')
      document.body.appendChild(link)
      link.click()
    },
    initSheet() {
      const config = { ...GC.Spread.Sheets.Designer.DefaultConfig }
      // 创建自定义按钮
      config.commandMap = {
        // export: {
        //   title: '自定义命令',
        //   text: '导出',
        //   bigButton: 'true',
        //   iconClass: 'iconfont icon-line-download',
        //   commandName: 'export',
        //   execute: (context, propertyName, fontItalicChecked) => {
        //     const json = this.spread.toJSON()
        //     this.excelIo.save(
        //       json,
        //       (blob) => {
        //         this.down(blob)
        //       },
        //       (e) => {}
        //     )
        //   },
        // },
        // create: {
        //   title: '自定义命令',
        //   text: '新增',
        //   bigButton: 'true',
        //   iconClass: 'iconfont icon-add',
        //   commandName: 'create',
        //   execute: (context, propertyName, fontItalicChecked) => {},
        // },
        // edit: {
        //   title: '自定义命令',
        //   text: '编辑',
        //   bigButton: 'true',
        //   iconClass: 'iconfont icon-line-edit',
        //   commandName: 'edit',
        //   execute: (context, propertyName, fontItalicChecked) => {
        //     this.sheet.options.isProtected = false
        //   },
        // },
        review: {
          title: '自定义命令',
          text: '提交审核',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-send',
          commandName: 'review',
          execute: () => {
            const notFilledFiledList = this.validCell()
            if (notFilledFiledList.length) {
              this.$message.warning(`${notFilledFiledList.join(',')}列为必填项，该列有数据未填写`)
              return
            }
            this.dataBatchSubmit()
          },
        },
        // task: {
        //   title: '自定义命令',
        //   text: '下发任务',
        //   bigButton: 'true',
        //   iconClass: 'iconfont icon-line-files',
        //   commandName: 'task',
        //   execute: (context, propertyName, fontItalicChecked) => {
        //     this.scopeDistuibutionVisible = true
        //   },
        // },
        saveTemplate: {
          title: '自定义命令',
          text: '保存',
          bigButton: 'true',
          iconClass: 'iconfont icon-bg-save',
          commandName: 'saveTemplate',
          execute: async () => {
            this.insertCollectData()
          },
        },
      }
      const customTab = {
        id: 'customTab',
        text: '填报命令',
        buttonGroups: [
          {
            commandGroup: {
              children: [
                {
                  direction: 'horizontal',
                  commands: ['create', 'edit', 'review', 'task', 'export', 'saveTemplate'],
                },
              ],
            },
          },
        ],
      }
      config.ribbon = _.uniqBy([...config.ribbon, customTab], 'id')
      const designer = new GC.Spread.Sheets.Designer.Designer(
        document.getElementById('gc-designer-container'),
        config
      )
      this.designer = designer
      this.spread = designer.getWorkbook()
      this.excelIo = new GC.Spread.Excel.IO()
      this.sheet = this.spread.getActiveSheet()
      // this.sheet.options.isProtected = false
      // this.disableMenu()
      this.sheet
        .getRange(0, 0, this.sheet.getRowCount(), this.sheet.getColumnCount())
        .hAlign(GC.Spread.Sheets.HorizontalAlign.center)
      this.sheet
        .getRange(0, 0, this.sheet.getRowCount(), this.sheet.getColumnCount())
        .vAlign(GC.Spread.Sheets.VerticalAlign.center)
      this.sheet.options.allowUserResize = true
      this.sheet.options.protectionOptions = {
        allowResizeRows: true,
        allowResizeColumns: true,
      }
      let originValue
      this.sheet.bind(GC.Spread.Sheets.Events.EditStarting, (e, info) => {
        const row = info.row
        const col = info.col
        originValue = this.sheet.getValue(row, col)
      })
      this.sheet.bind(GC.Spread.Sheets.Events.EditEnd, (e, info) => {
        const row = info.row
        const col = info.col
        this.$confirm('确认编辑次单元格？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {})
          .catch(() => {
            this.sheet.setValue(row, col, originValue)
            info.cancel = true
          })
      })
      // this.disableMenu()
    },
  },
}
</script>

<style lang="scss" scoped>

.el-tree-node__content {
  height: auto;
}
.detail {
  border-left: 2px solid #e9e9e9;
}
::v-deep .fileButton {
  display: none;
}

</style>
